import "./style.css";
import ReactDOM from "react-dom/client";
import { Main } from "./Main";

const root = ReactDOM.createRoot(document.querySelector("#root"));

root.render(
  <>
    <Main></Main>
  </>
);


